import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './ContactUs.css';

export class ContactUs extends Component {
  render() {
    return (
      <div className="Regular-page ui stackable center aligned padded column grid">
        <div className="four wide column">
        </div>

        <div className="three wide column center aligned">
          <Link to="/">
            <button className="ui animated button">
              <div className="visible content">Back</div>
              <div className="hidden content">
                <i aria-hidden="true" className="left arrow icon"></i>
              </div>
            </button>
          </Link>

          <div>
            &nbsp;
          </div>

          <div>
            &nbsp;
          </div>

          <div className="left-aligned">

            <h3>Contact Us</h3>

            <p>
              <strong>Email</strong><br/>
              info(at)permutize.com
            </p>

            <p>
              <strong>Snail Mail</strong><br/>
              Permutize LLC<br/>
              981 Mission Street<br/>
              San Francisco, CA 94103<br/>
            </p>

          </div>

        </div>

        <div className="three wide column">
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.js